import { type ResponseGenerics } from '@dni-types/utilities/response'
import { createMutationHelper } from '@utils/swr'
import { type AdminLogin } from '../../model/campaign'

export type AdminLoginResponse = ResponseGenerics<AdminLogin>
export interface AdminLoginRequest {
  code: string
  password: string
}

const {
  useMutation,
} = createMutationHelper<`/campaigns/${string}/admin/login`, AdminLoginResponse, AdminLoginRequest>({
  client: 'fortune',
  key: '/campaigns',
  fetcher: (_url, { arg, client }) => {
    return client.post(`/campaigns/${arg.code}/admin/login`, {
      password: arg.password,
    })
  },
})

export const useApiAdminLogin = useMutation
